import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"icons"}},_vm._l((_vm.icon_bar),function(x,index){return _c(VBtn,{key:index,class:_vm.small_screen ? 'ml-2' : '',attrs:{"small":_vm.small_screen,"icon":""},on:{"click":function($event){return _vm.open_right_navigation_drawer(x)}}},[_c(VIcon,{attrs:{"color":_vm.selected_menu === x ? 'primary' : x.color}},[_vm._v(" "+_vm._s(x.icon)+" ")])],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }